<template>
  <PageLayout
    :is-loading="isLoading"
    page-title="Profile"
    :show-banner="false"
    :show-sponsors="false"
    :hide-sidebar="false"
  >
    <!-- Profile Header Section -->
    <div class="profile-header-section">
      <div class="profile-header-card">
        <div class="profile-avatar-container">
          <img 
            :src="getUserImage(detailUser.image)" 
            class="profile-avatar" 
            alt="Profile" 
            @error="handleImageError"
          />
        </div>
        <h2 class="profile-name">{{ detailUser.name || 'Della Juliyanti' }}</h2>
        <div class="edit-icon" @click="editProfile">
          <i class="mdi mdi-pencil"></i>
        </div>
      </div>
    </div>

    <!-- Profile Information Section -->
    <div class="profile-content-section">
      <div class="info-section">
        <h3 class="section-title">Profile Information</h3>
        
        <div class="info-item" @click="editBasicInfo">
          <div class="info-icon basic-info">
            <i class="mdi mdi-account"></i>
          </div>
          <span class="info-label">Basic Information</span>
          <div class="edit-button">
            <i class="mdi mdi-pencil"></i>
          </div>
        </div>

        <div class="info-item" @click="editPrivacyInfo">
          <div class="info-icon privacy-info">
            <i class="mdi mdi-lock"></i>
          </div>
          <span class="info-label">Privacy Information</span>
          <div class="edit-button">
            <i class="mdi mdi-pencil"></i>
          </div>
        </div>

        <div class="info-item" @click="editAdditionalInfo">
          <div class="info-icon additional-info">
            <i class="mdi mdi-information"></i>
          </div>
          <span class="info-label">Additional Information</span>
          <div class="edit-button">
            <i class="mdi mdi-pencil"></i>
          </div>
        </div>
      </div>

      <!-- Social Media Information Section -->
      <div class="info-section">
        <h3 class="section-title">Social Media Information</h3>
        
        <div class="info-item" @click="editInstagram">
          <div class="info-icon instagram">
            <i class="mdi mdi-instagram"></i>
          </div>
          <div class="social-info">
            <span class="social-platform">Instagram</span>
            <span class="social-stats">{{ formatFollowers(detailUser.followers_instagram) || '5.2 K' }}</span>
            <span class="social-detail">(Engagement Info)</span>
          </div>
          <div class="edit-button">
            <i class="mdi mdi-pencil"></i>
          </div>
        </div>

        <div class="info-item" @click="editTiktok">
          <div class="info-icon tiktok">
            <i class="mdi mdi-music-note"></i>
          </div>
          <div class="social-info">
            <span class="social-platform">Tiktok</span>
            <span class="social-stats">{{ formatFollowers(detailUser.followers_tiktok) || '2 K' }}</span>
            <span class="social-detail">(Engagement Info)</span>
          </div>
          <div class="edit-button">
            <i class="mdi mdi-pencil"></i>
          </div>
        </div>

        <div class="info-item" @click="editDevicePortfolio">
          <div class="info-icon device">
            <i class="mdi mdi-cellphone"></i>
          </div>
          <span class="info-label">Device & Portfolio</span>
          <div class="edit-button">
            <i class="mdi mdi-pencil"></i>
          </div>
        </div>
      </div>

      <!-- Sign Out Button -->
      <div class="sign-out-section">
        <button class="sign-out-btn" @click="logout">
          <span>Sign Out</span>
          <i class="mdi mdi-logout-variant"></i>
        </button>
      </div>
    </div>
  </PageLayout>
</template>

<script>
import AppPageLayout from '@/components/ui/PageLayout.vue';

export default {
  name: "NewProfile",
  components: {
    PageLayout: AppPageLayout
  },
  data() {
    return {
      isLoading: false,
      detailUser: {},
      errors: [],
    };
  },
  watch: {
    '$route'(to) {
      // Refetch data when navigating to profile page
      if (to.path === '/user/profile') {
        this.fetchIt();
      }
    }
  },
  methods: {
    editProfile() {
      this.$router.push('/user/profile/edit?section=profile');
    },
    
    editBasicInfo() {
      this.$router.push('/user/profile/edit?section=basic');
    },
    
    editPrivacyInfo() {
      this.$router.push('/user/profile/edit?section=privacy');
    },
    
    editAdditionalInfo() {
      this.$router.push('/user/profile/edit?section=additional');
    },
    
    editInstagram() {
      this.$router.push('/user/profile/edit?section=social');
    },
    
    editTiktok() {
      this.$router.push('/user/profile/edit?section=social');
    },
    
    editDevicePortfolio() {
      this.$router.push('/user/profile/edit?section=social');
    },

    formatFollowers(count) {
      if (!count || count === 0) return '0';
      if (count >= 1000000) {
        return (count / 1000000).toFixed(1) + 'M';
      } else if (count >= 1000) {
        return (count / 1000).toFixed(1) + 'K';
      }
      return count.toString();
    },

    getUserImage(imageUrl) {
      // Return default image if no image URL or if it's null/empty
      if (!imageUrl || imageUrl === null || imageUrl === '') {
        return '/assets/images/maternity.png';
      }
      return imageUrl;
    },

    handleImageError(event) {
      // Set default image when image fails to load
      event.target.src = '/assets/images/maternity.png';
    },

    error(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: message,
      });
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    logout() {
      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
        console.log(response);
      });
      this.$logoutUser();
      window.location.href = '/';
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      const userId = userDatas.sub?.user_id;
      
      if (userId) {
        this.fetchUserData(userId);
      } else {
        // Fallback to localStorage if no user_id
        this.detailUser = userDatas.sub || {};
      }
    },

    fetchUserData(userId) {
      this.isLoading = true;
      const baseURI = this.$settings.endPoint + "get-user/detail/" + userId;
      
      this.$http
        .get(baseURI, {
          timeout: 10000,
          headers: {
            'AppToken': this.$settings.jwtSecret,
          }
        })
        .then((response) => {
          this.isLoading = false;
          if (response.data.status === 200) {
            this.detailUser = response.data.datas;
            // Update localStorage with fresh data
            this.updateLocalStorage(response.data.datas);
            // Emit event to update other components (like sidebar)
            this.$root.$emit('userDataUpdated');
          } else {
            // Fallback to localStorage data
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub || {};
          }
        })
        .catch(error => {
          this.isLoading = false;
          console.log('Error fetching user data:', error);
          // Fallback to localStorage data
          const userDatas = this.$getUserInfo();
          this.detailUser = userDatas.sub || {};
          this.handleError(error);
        });
    },

    updateLocalStorage(userData) {
      try {
        const currentUserData = JSON.parse(localStorage.getItem('userModels'));
        if (currentUserData && currentUserData.sub) {
          // Update the user data in localStorage
          currentUserData.sub = { ...currentUserData.sub, ...userData };
          localStorage.setItem('userModels', JSON.stringify(currentUserData));
        }
      } catch (error) {
        console.log('Error updating localStorage:', error);
      }
    },

    success(message) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: message,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000);
    },

    handleError(error) {
      if (error.response) {
        if (error.response.status === 422) {
          this.resultError(error.response.data.errors);
        } else if (error.response.status === 500) {
          this.$router.push('/server-error');
        } else if (error.response.status === 401) {
          this.$router.push("/authorized-error");
        } else {
          this.$router.push('/page-not-found');
        }
      } else if (error.code === "ECONNABORTED") {
        this.error("Please check your internet connection");
      } else {
        this.error("An error occurred. Please try again.");
      }
    }
  },
  created: function () {},
  mounted() {
    this.loading();
    this.fetchIt();
  },
};
</script>

<style scoped>
/* ========================================= */
/* PROFILE HEADER SECTION                    */
/* ========================================= */
.profile-header-section {
  padding: 24px 32px;
  margin: 0 auto 32px auto;
  border-radius: 16px;
  max-width: 1200px;
  width: calc(100% - 64px);
}

.profile-header-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  position: relative;
  display: flex;
  align-items: center;
  gap: 16px;
}

.profile-avatar-container {
  flex-shrink: 0;
}

.profile-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 3px solid #4A90E2;
  object-fit: cover;
}

.profile-name {
  flex: 1;
  margin: 0;
  color: #1F2937;
  font-size: 1.5rem;
  font-weight: 700;
}

.edit-icon {
  position: absolute;
  right: 16px;
  background: #F2994A;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1.1rem;
}

.edit-icon:hover {
  background: #e0874a;
  transform: scale(1.1);
}

/* ========================================= */
/* PROFILE CONTENT SECTION                   */
/* ========================================= */
.profile-content-section {
  padding: 0 32px;
  margin: 0 auto 32px auto;
  max-width: 1200px;
  width: calc(100% - 64px);
}

.info-section {
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.section-title {
  margin: 0 0 24px 0;
  color: #1F2937;
  font-size: 1.25rem;
  font-weight: 700;
}

.info-item {
  display: flex;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #F3F4F6;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 8px;
}

.info-item:last-child {
  border-bottom: none;
}

.info-item:hover {
  background-color: #F9FAFB;
  padding-left: 12px;
  padding-right: 12px;
}

.info-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  color: white;
  font-size: 1.2rem;
  flex-shrink: 0;
}

.info-icon.basic-info {
  background: #4A90E2;
}

.info-icon.privacy-info {
  background: #4A90E2;
}

.info-icon.additional-info {
  background: #4A90E2;
}

.info-icon.instagram {
  background: #4A90E2;
}

.info-icon.tiktok {
  background: #4A90E2;
}

.info-icon.device {
  background: #4A90E2;
}

.info-label {
  flex: 1;
  font-size: 1rem;
  font-weight: 500;
  color: #1F2937;
}

.social-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.social-platform {
  font-size: 1rem;
  font-weight: 500;
  color: #1F2937;
  margin-bottom: 2px;
}

.social-stats {
  font-size: 0.9rem;
  font-weight: 600;
  color: #1F2937;
}

.social-detail {
  font-size: 0.8rem;
  color: #6B7280;
}

.edit-button {
  background: #F2994A;
  color: white;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.edit-button:hover {
  background: #e0874a;
  transform: scale(1.1);
}

/* ========================================= */
/* SIGN OUT SECTION                          */
/* ========================================= */
.sign-out-section {
  text-align: center;
  margin-top: 32px;
}

.sign-out-btn {
  background: linear-gradient(135deg, #F2994A 0%, #e0874a 100%);
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 auto;
  box-shadow: 0 4px 16px rgba(242, 153, 74, 0.3);
}

.sign-out-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(242, 153, 74, 0.4);
}

/* ========================================= */
/* MOBILE RESPONSIVE STYLES                  */
/* ========================================= */
@media (max-width: 768px) {
  .profile-header-section,
  .profile-content-section {
    width: calc(100% - 40px);
    margin: 0 20px 24px 20px;
    padding: 20px;
  }
  
  .profile-header-card {
    padding: 20px;
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }
  
  .profile-avatar {
    width: 70px;
    height: 70px;
  }
  
  .profile-name {
    font-size: 1.25rem;
  }
  
  .edit-icon {
    position: static;
    width: 36px;
    height: 36px;
    font-size: 1rem;
  }
  
  .info-section {
    padding: 20px;
    margin-bottom: 20px;
  }
  
  .section-title {
    font-size: 1.1rem;
    margin-bottom: 20px;
  }
  
  .info-item {
    padding: 12px 0;
  }
  
  .info-icon {
    width: 40px;
    height: 40px;
    margin-right: 12px;
    font-size: 1rem;
  }
  
  .info-label {
    font-size: 0.9rem;
  }
  
  .social-platform {
    font-size: 0.9rem;
  }
  
  .social-stats {
    font-size: 0.8rem;
  }
  
  .social-detail {
    font-size: 0.75rem;
  }
  
  .edit-button {
    width: 32px;
    height: 32px;
    font-size: 0.9rem;
  }
  
  .sign-out-btn {
    padding: 12px 28px;
    font-size: 0.9rem;
  }
}
</style>